import type { EffectCallback } from 'react'
import { useEffect, useEffectEvent } from 'react'

/** Runs `effect` once the component mounts (its cleanup on unmount), reading the props and state of that render. */
export const useMountEffect = (effect: EffectCallback) => {
  const run = useEffectEvent(effect)

  useEffect(() => run(), [])
}
